<template>
  <RewardsMain v-if="userReady" />
  <MissedRewards v-else-if="rewardsEnabled" />
  <ComingSoon v-else />
</template>

<script>

import ComingSoon from '../ComingSoon'
import MissedRewards from './MissedRewards'
import RewardsMain from './Main'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'RewardsBalanceTab',

  components: { ComingSoon, MissedRewards, RewardsMain },

  computed: {
    ...mapGetters('auth', ['me']),

    userReady() {
      return this.me.rewards_beta && this.me.has_approved_w9
    },

    rewardsEnabled() {
      return this.me.rewards_beta
    },
  },

  methods: {
    ...mapActions('auth', ['loadMe']),
  },

  created() {
    this.loadMe()
  }
}
</script>
